import Modal from "react-bootstrap/Modal";
import { useMemo, useRef } from "react";
import { toast } from "react-toastify";

const copyText = async (text) => {
  if (!text) return false;
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
};

const PromotingShareModal = ({ show, onHide, shareUrl, promoCode }) => {
  const shareInputRef = useRef(null);
  const promoInputRef = useRef(null);

  const promoValue = useMemo(() => promoCode || "", [promoCode]);

  const handleCopy = async (value, label) => {
    if (!value) {
      toast.error(`No ${label.toLowerCase()} available`);
      return;
    }
    const copied = await copyText(value);
    if (copied) {
      toast.success(`${label} copied`);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      animation={false}
      dialogClassName="event-share-modal-dialog"
      contentClassName="event-share-modal"
    >
      <Modal.Header className="event-share-modal-header" closeButton>
        <Modal.Title>Share Promo Link</Modal.Title>
      </Modal.Header>
      <Modal.Body className="event-share-modal-body">
        <div className="event-share-field">
          <label htmlFor="promotingShareLink">Promo Link:</label>
          <div className="event-share-input-row">
            <input
              ref={shareInputRef}
              id="promotingShareLink"
              className="event-share-input"
              type="text"
              value={shareUrl}
              readOnly
            />
            <button
              type="button"
              className="event-share-copy-btn"
              aria-label="Copy promo link"
              onClick={() => handleCopy(shareUrl, "Promo link")}
            >
              <i className="bi bi-copy" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="event-share-modal-footer">
        <button
          type="button"
          className="event-share-modal-btn-close"
          onClick={onHide}
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default PromotingShareModal;
